<script setup lang="ts">
import { RouterLink } from 'vue-router'
import { useSeo } from '@/composables/useSeo'
import PageLayout from '@/components/layout/PageLayout.vue'

useSeo({
  title: 'Page Not Found',
  description: 'The requested page could not be found on ClearRand.',
  path: '/404',
  noindex: true,
})
</script>

<template>
  <PageLayout title="Page not found" description="We couldn't find the page you were looking for.">
    <p>
      Try the <RouterLink to="/">home page</RouterLink> or
      <RouterLink to="/calculators">browse calculators</RouterLink>.
    </p>
  </PageLayout>
</template>

<style scoped>
p {
  color: var(--color-text-muted);
}
</style>
